import { createRouter, createWebHistory } from 'vue-router'
import UserLogin from '../components/LoginForm.vue'
import UserRegister from '../components/RegisterForm.vue'
import UserHome from '../views/UserHome.vue'
import ChatPage from '../views/match/ChatPage.vue'
import MatchedList from '../views/match/MatchedList.vue'
import MembershipDetail from '../views/membership/MembershipDetail.vue'
import MembershipPlans from '../views/membership/MembershipPlans.vue'
import CheckinPage from '@/views/checkin/CheckinPage.vue'
import MembershipPayment from '@/views/membership/MembershipPayment.vue'
import SecKillDetail from '../views/seckill/SecKillDetail.vue'
import OrderDetail from '../views/order/OrderDetail.vue'
import OrderPayment from '../views/order/OrderPayment.vue'
import AddressManage from '../views/order/AddressManage.vue'
import MyOrders from '../views/order/MyOrders.vue'
import ProductList from '../views/product/ProductList.vue'
import ProductDetail from '../views/product/ProductDetail.vue'
import ShopingCart from '../views/product/ShopingCart.vue'
import CheckOut from '../views/order/CheckOut.vue'
import Near from '../views/match/NearPersons.vue'
import AiRecommend from '../views/match/AiRecommend.vue'
import PaymentRedirectAli from '../views/order/PaymentRedirectAli.vue'
import VirtualCharacter from '../views/match/VirtualCharacter.vue'
import VirtualChat from '../views/match/VirtualChat.vue'
import FriendList from '../views/match/FriendList.vue'
import FriendApply from '../views/match/FriendApply.vue'
import GameRoom from '../views/game/GameRoom.vue'
import GameRules from '../views/game/GameRules.vue'
import socketService from '@/api/socket'

const routes = [
  {
    path: '/login',
    name: 'UserLogin',
    component: UserLogin,
    meta: { guest: true }
  },
  {
    path: '/register',
    name: 'UserRegister',
    component: UserRegister,
    meta: { guest: true }
  },
{
  path: '/',  // 根路径路径指向指向聊天页面
  name: 'ChatPage',
  component: ChatPage,
  meta: { requiresAuth: true }
},
{
  path: '/user-home',  // 用户首页页使用单独路径
  name: 'UserHome',
  component: UserHome,
  meta: { requiresAuth: true }
}
,
{
  path: '/virtual',
  name: 'VirtualCharacter',
  component: VirtualCharacter,
  meta: { requiresAuth: true }
},
{
  path: '/virtual-chat',
  name: 'VirtualChat',
  component: VirtualChat,
  meta: { requiresAuth: true }
},

  {
  path: '/match/ai-recommend', 
  name: 'AiRecommend',
  component: AiRecommend,
  meta: { 
    title: 'Ai推荐',
    requiresAuth: true  
  }
},
  {
    path: '/match/matched',
    name: 'MatchedList',
    component: MatchedList,
    meta: { requiresAuth: true }
  },
    // 新增会员相关路由
{
    path: '/membership/detail',
    name: 'MembershipDetail',
    component: MembershipDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/membership/plans',
    name: 'MembershipPlans',
    component: MembershipPlans,
    meta: { requiresAuth: true }
  },
  {
    path: '/checkin',
    name: 'CheckinPage',
    component: CheckinPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/membership/pay',
    name: 'MembershipPayment',
    component: MembershipPayment,
    meta: { requiresAuth: true }
  },
  {
    path: '/seckill',
    name: 'SecKillDetail',
    component: SecKillDetail,
    meta: { requiresAuth: true }
  },
  {
  path: '/order/detail/:orderSn',
  name: 'OrderDetail',
  component: OrderDetail,
  meta: { requiresAuth: true }
  },
  // 订单支付
  {
  path: '/order/pay/:orderSn',
  name: 'OrderPayment',
  component: OrderPayment,
  meta: { requiresAuth: true }
  },
  // 添加地址管理页面路由
  {
    path: '/address',
    name: 'AddressManage', // 路由名称（唯一）
    component: AddressManage, // 对应组件
    meta: { 
      title: '地址管理' ,
      requiresAuth: true 
    }
  },
  {
  path: '/my-orders',
  name: 'MyOrders',
  component: MyOrders,
  meta: { title: '我的订单' ,
          requiresAuth: true 
  }
 },
 {
  path: '/products',
  name: 'ProductList',
  component: ProductList,
  meta: { 
    title: '在线商城',
    requiresAuth: true 
  }
},
{
  path: '/product/detail/:id',  // 匹配商品详情路径，带id参数
  name: 'ProductDetail',
  component: ProductDetail,
  meta: { 
    title: '商品详情',
    requiresAuth: true  // 商品详情通常需要登录才能查看，保持与其他页面一致
  }
},
{
  path: '/cart',  // 匹配商品详情路径，带id参数
  name: 'ShopingCart',
  component: ShopingCart,
  meta: { 
    title: '购物车',
    requiresAuth: true  // 商品详情通常需要登录才能查看，保持与其他页面一致
  }
},
{
  path: '/order/checkout',  // 匹配商品详情路径，带id参数
  name: 'CheckOut',
  component: CheckOut,
  meta: { 
    title: '购物车结算',
    requiresAuth: true  // 商品详情通常需要登录才能查看，保持与其他页面一致
  }
},
{
  path: '/near',  // 匹配商品详情路径，带id参数
  name: 'Near',
  component: Near,
  meta: { 
    title: '附近的人',
    requiresAuth: true  // 商品详情通常需要登录才能查看，保持与其他页面一致
  }
},
  {
    path: '/payment/redirect',
    name: 'PaymentRedirectAli',
    component: PaymentRedirectAli,
    meta: { title: '支付跳转' }
  },
   // 通配符路由放在最后
  {
    path: '/friend',
    name: 'FriendList',
    component: FriendList,
    meta: { requiresAuth: true }
  },
  {
    path: '/friend/applies',
    name: 'FriendApply',
    component: FriendApply,
    meta: { requiresAuth: true }
  },
  {
    path: '/game/room/:roomId',
    name: 'GameRoom',
    component: GameRoom,
    meta: { requiresAuth: true }
  },
  {
    path: '/game/rules',
    name: 'GameRules',
    component: GameRules,
    meta: { requiresAuth: true }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/login'
  }
  
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('accessToken')

  if (to.meta.requiresAuth && !isAuthenticated) {
    socketService.close()
    next('/login')
  } else if (to.meta.guest && isAuthenticated) {
    next('/')
  } else {
    next()
  }
})

// 统一设置页面标题
router.afterEach(() => {
  document.title = '时光同频'
})

export default router
